export default __webpack_public_path__ + "static/media/icon2_blue.5c74a6f6.svg";